if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      quantityInputSticky = undefined;
      quantityFormSticky = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      currentFeaturedMediaId = undefined;
      
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      
      
      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input-primary');
        this.quantityInputSticky = this.querySelector('.quantity__input-sticky');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        
        this.currentFeaturedMediaId = this.getSelectedVariant(this)?.featured_media?.id;

        /*自定义在设置不显示产品featured image时，在url没有variant参数的情况下，切换到产品特色图片。有参数的时候保持显示当前变体图片*/
       this.updateFeaturedMedia();
        
      }

      updateFeaturedMedia(){
         const urlParams = new URLSearchParams(window.location.search);
        const urlVariantId = urlParams.get('variant');
        const featuredMediaId = parseInt(this.dataset.featuredMedia, 10);
        let hasFeatured = false;

        if(featuredMediaId == this.currentFeaturedMediaId || this.currentFeaturedMediaId == undefined){
          hasFeatured = true;
        }
        
          if (!urlVariantId && hasFeatured == false){
            const mediaGallery = this.querySelector('media-gallery ul');
            if (mediaGallery && featuredMediaId) {
              const mediaItems = Array.from(mediaGallery.querySelectorAll('li[data-media-id]'));
              const mainFeaturedMediaId = `${this.dataset.section}-${featuredMediaId}`;
              const mainItem = mediaItems.find(item => item.dataset.mediaId === mainFeaturedMediaId);
              if (mainItem) {
                // 构造fetch请求，刷新页面内容
                const requestUrl = `${this.dataset.url}?section_id=${this.sectionId}`;
                fetch(requestUrl)
                  .then((response) => response.text())
                  .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    // 用updateMedia刷新页面，并切换到featuredMediaId
                    this.updateMedia(html, featuredMediaId);
                    this.currentFeaturedMediaId = featuredMediaId;
                  });
              }
            }
          }  
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput && !this.quantityInputSticky) return;

        this.quantityForm = this.querySelector('.product-form__quantity-primary');
        this.quantityFormSticky = this.querySelector('.product-form__quantity-sticky');
        if (!this.quantityForm && !this.quantityFormSticky) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = (this.dataset.url !== productUrl) || this.querySelector('li[data-gang-option]') !== null;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects[data-primary]');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
        const variantSelectsAlt = html.querySelector('variant-selects[data-sticky]');
        if (variantSelectsAlt) {
          HTMLUpdateUtility.viewTransition(this.variantSelectorsAlt, variantSelectsAlt, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          const previousFeaturedMediaId = this.currentFeaturedMediaId;
          const newFeaturedMediaId = variant?.featured_media?.id;
          
           if (newFeaturedMediaId !== previousFeaturedMediaId) {
            this.updateMedia(html, newFeaturedMediaId);
            this.currentFeaturedMediaId = newFeaturedMediaId;
          }

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('paylater');//自定义更新pay later的价格
          updateSourceFromDestination('badge');//自定义更新产品图片上方的badge
          updateSourceFromDestination('promo-info');
          updateSourceFromDestination('Price-Alt');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            theme.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

            /*自定义改变updateCartButton data-variant-id*/
          this.updateCartButton(variant?.id);
          
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}--alt`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, theme.variantStrings.unavailable);

        const selectors = ['price', 'Price-Alt', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const input = this.quantityInput || this.quantityInputSticky;
        const data = {
          cartQuantity: input?.dataset.cartQuantity ? parseInt(input.dataset.cartQuantity) : 0,
          min: input?.dataset.min ? parseInt(input.dataset.min) : 1,
          max: input?.dataset.max ? parseInt(input.dataset.max) : null,
          step: input?.step ? parseInt(input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        if(this.quantityInput) this.quantityInput.min = min;
        if(this.quantityInputSticky) this.quantityInputSticky.min = min;

        if (max) {
          if(this.quantityInput) this.quantityInput.max = max;
          if(this.quantityInputSticky) this.quantityInputSticky.max = max;
        } else {
          this.quantityInput?.removeAttribute('max');
          this.quantityInputSticky?.removeAttribute('max');
        }
        if(this.quantityInput) this.quantityInput.value = min;
        if(this.quantityInputSticky) this.quantityInputSticky.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        //this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            //this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput && !this.quantityInputSticky) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`) || html.getElementById(`Quantity-Form-${sectionId}-sticky`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm?.querySelector(selector);
          const currentSticky = this.quantityFormSticky?.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if(!updated) continue;
          if (!current && !currentSticky) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current?.setAttribute(attribute, valueUpdated);
                currentSticky?.setAttribute(attribute, valueUpdated);
              } else {
                current?.removeAttribute(attribute);
                currentSticky?.removeAttribute(attribute);
              }
            }
          } else {
            if(current) current.innerHTML = updated.innerHTML;
            if(currentSticky) currentSticky.innerHTML = updated.innerHTML;
          }
        }
      }

       /*自定义改变updateCartButton data-variant-id*/
    updateCartButton(variantId){
      const updateCartButton = document.querySelector('update-cart');
      if(!updateCartButton) return;
    
      updateCartButton.dataset.variantId = variantId;
    }
      
      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects[data-primary]');
      }

      get variantSelectorsAlt() {
        return this.querySelector('variant-selects[data-sticky]');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

if (!customElements.get('top-navigation')) {
  customElements.define(
    'top-navigation',
    class topNavigation extends HTMLElement {
      constructor() {
        super();
        this.isManualScroll = false;
        this.mediaQuery = window.matchMedia('(max-width: 767px)');
        this.handleScroll = this.scrollListener.bind(this); // 缓存监听器引用
        this.lastScrollTop = window.scrollY;
        this.targetSection = document.querySelector('[data-tab="top-navigation-overview"]');
      }

      connectedCallback() {
        this.handleMediaQueryChange();
        this.mediaQuery.addEventListener('change', this.handleMediaQueryChange.bind(this));
      }

      handleMediaQueryChange() {
        const isMobile = this.mediaQuery.matches;
        if (isMobile) {
          this.bindMobileEvents();
          this.updateActiveSection();
        } else {
          this.unbindMobileEvents();
          this.resetRadioState();
        }
      }

      bindMobileEvents() {
        this.navInputs = this.querySelectorAll('input[type="radio"]');
        this.navInputs.forEach(input => {
          input.addEventListener('click', this.handleInputClick.bind(this));
        });
        window.addEventListener('scroll', this.handleScroll);
      }

      unbindMobileEvents() {
        if (this.navInputs) {
          this.navInputs.forEach(input => {
            input.removeEventListener('click', this.handleInputClick.bind(this));
          });
        }
        window.removeEventListener('scroll', this.handleScroll);
      }

      handleInputClick(e) {
        this.isManualScroll = true;
        const targetSection = document.querySelector(`[data-tab="${e.target.id}"]`);
        targetSection?.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => (this.isManualScroll = false), 1000);
      }

      updateActiveSection() {
        if (!this.mediaQuery.matches || this.isManualScroll) return;

        const sections = document.querySelectorAll('[data-tab^="top-navigation"]');
        const viewportThreshold = window.innerHeight * 0.3;
        let activeSection = null;

        sections.forEach(section => {
          const rect = section.getBoundingClientRect();
          const isSectionActive = rect.top <= viewportThreshold && rect.bottom >= viewportThreshold;

          if (isSectionActive) {
            if (!activeSection || rect.top < activeSection.getBoundingClientRect().top) {
              activeSection = section;
            }
          }
        });

        if (!activeSection) {
          let minDistance = Infinity;
          sections.forEach(section => {
            const distance = Math.abs(section.getBoundingClientRect().top);
            if (distance < minDistance) {
              activeSection = section;
              minDistance = distance;
            }
          });
        }

        if (activeSection) {
          const targetRadio = document.getElementById(activeSection.dataset.tab);
          if (targetRadio) targetRadio.checked = true;
        }
      }

      scrollListener() {
        if (!this.mediaQuery.matches) return;

        const currentScroll = window.scrollY;
        const isScrollingDown = currentScroll > this.lastScrollTop;
        const targetTop = this.targetSection?.getBoundingClientRect().top + window.scrollY;
        const distanceToTop = targetTop - currentScroll;

        if (isScrollingDown && currentScroll >= targetTop - 160) {
          this.showSticky();
        } else if (!isScrollingDown && currentScroll < targetTop - 160) {
          this.hideSticky();
        }

        this.lastScrollTop = currentScroll;

        let isScrolling;
        window.clearTimeout(isScrolling);
        isScrolling = setTimeout(() => this.updateActiveSection(), 100);
      }

      showSticky() {
          this.classList.add('top-nav-sticky');     
      }
      hideSticky() {   
          this.classList.remove('top-nav-sticky');
      }
      resetRadioState() {
        this.querySelectorAll('input[type="radio"]').forEach(input => {
          input.checked = false;
        });
      }
      disconnectedCallback() {
        this.unbindMobileEvents();
        this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange);
      }
    }
  );
}
/*
*自定义移动评论模块位置
*/
 document.addEventListener('DOMContentLoaded', function () {
    const reviews = document.getElementById('judgeme_product_reviews');

    if (!reviews) return;

    function moveReviews() {
      const screenWidth = window.innerWidth;

      if (screenWidth < 768) {
        // 移动到移动端容器
        const mobileTarget = document.querySelector('#mobile-review-container');
        if (mobileTarget && !mobileTarget.contains(reviews)) {
          mobileTarget.appendChild(reviews);
        }
      } else {
        // 移动回桌面端容器
        const desktopTarget = document.querySelector('#desktop-review-container');
        if (desktopTarget && !desktopTarget.contains(reviews)) {
          desktopTarget.appendChild(reviews);
        }
      }
    }

    moveReviews();
    window.addEventListener('resize', moveReviews);
  });

  /* 预估送货时间 */

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.estimated-delivery');
  if (!el) return;

  const processingDays = Number(el.dataset.processingDays || 0);
  const shippingMin = Number(el.dataset.shippingMin || 0);
  const shippingMax = Number(el.dataset.shippingMax || 0);

  // 固定从当天 00:00 开始算，避免刷新漂移
  const startDate = new Date();
  startDate.setHours(0, 0, 0, 0);

  // ✅ 排除周末
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;

    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay(); // 0=Sun, 6=Sat
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return d;
  };

  const minDate = addBusinessDays(
    startDate,
    processingDays + shippingMin
  );

  const maxDate = addBusinessDays(
    startDate,
    processingDays + shippingMax
  );

  // 使用 toLocaleDateString 自动处理星期几缩写和日期格式
  const formatDate = (date) =>
    date.toLocaleDateString('en-US', {
      weekday: 'short', // 星期几的缩写
      month: 'short',   // 月份的缩写
      day: 'numeric',   // 日
    });

  el.textContent =
    `${formatDate(minDate)} – ${formatDate(maxDate)}`;
});


/* table view more */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.table-view-more');
  if (!btn) return;

  const table = document.querySelector(btn.dataset.table);
  if (!table) return;

  const rows = table.querySelectorAll('tr');
  const expanded = btn.dataset.expanded === 'true';

  rows.forEach((row, index) => {
    if (index >= 5) {
      row.style.display = expanded ? 'none' : 'table-row';
    }
  });

  btn.dataset.expanded = (!expanded).toString();
  btn.textContent = expanded ? 'View more' : 'View less';
});
